import axiosInstance from "../Interceptors/ResponseInterceptor";

export const updateActivityDetails = async (activityId, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.patch(
        `/api/site-activities/${activityId}`,
        body
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};
export const reInitiateActivity = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        `/api/site-activities/reinitiate`,
        body
      );
      resolve(response);
    } catch (error) {
      console.error("Error in reInitiateActivity:", error);
      reject(error);
    }
  });
};

export const getAssignee = async (silKey) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(
        `/stakeholders/company/${silKey}`
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in getAssignee:", error);
      reject(error);
    }
  });
};
